import { useBackButtonHandler, UseBackButtonHandlerOptions } from '@/hooks/useBackButtonHandler';
import { backLogger } from '@/services/backLogger';

const BackButtonHandler = (options: UseBackButtonHandlerOptions = {}) => {
  const { logger, allowAppExit, ...rest } = options;

  useBackButtonHandler({
    ...rest,
    allowAppExit,
    logger: logger ?? backLogger,
  });
  return null;
};

export default BackButtonHandler;
